export const settings = {
  project: {
    yandexApiKey: process.env.REACT_APP_YANDEX_API_KEY || ''
  },
  auth: {
    token: 'hn_u',
  },
  api: {
    url: process.env.REACT_APP_APP_API_URl || ''
  }
}